import type { SVGProps } from 'react';
import { colors } from '@anyroad/theme';

export const Clock = (props: SVGProps<SVGSVGElement>) => {
  const { fill = colors.text.icon } = props;

  return (
    <svg
      height="512px"
      role="img"
      version="1.1"
      viewBox="0 0 512 512"
      width="512px"
      {...props}
    >
      <title>{'clock'}</title>
      <g transform="scale(1,-1) translate(0 -512)">
        <path
          d="M256 471c118 0 215-97 215-215 0-119-97-215-215-215-118 0-215 97-215 215 0 118 97 215 215 215m0 27c-134 0-242-108-242-242 0-134 108-242 242-242 134 0 242 108 242 242 0 134-108 242-242 242z m14-223l0 145-39 0 0-179 122 0 0 34z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
